import actions from '@/store/modules/myPOs/actions';
import mutations from '@/store/modules/myPOs/mutations';


const state = {
  myPOs: [],
  isLoading: false,
  paginationInfo: {
    pageNumber: 1,
    pageSize: 5,
    sortBy: 'id',
    sortOrder: 'desc',
  },
  filterQuery: '',
  myPOsTotal: 0,
};

// getters
const getters = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
